import React from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import AuthWrapper from "@pages/auth/AuthWrapper";
import { ContactsType } from "@/utils/types/ContactsType";
import axios from "axios";
import api from "@/api/api";

const ActivateContainer = () => {
  const [searchParams] = useSearchParams();

  const activate = useQuery<ContactsType, Error>(
    ["activate"],
    async () => {
      const { data } = await api.get(
        "/api/v1/activate?code=" + searchParams.get("code")
      );
      return data;
    },
    { retry: false }
  );

  return (
    <AuthWrapper>
      {activate.isSuccess && "Success"}
      {activate.isError && "Error"}
      {activate.isLoading && "Loading..."}
    </AuthWrapper>
  );
};

export default ActivateContainer;
